module.exports = __webpack_public_path__ + "static/media/drop.658472e9.svg";